import moment from "moment-jalaali";
import parse from 'html-react-parser';

import Bar from "../Common/Bar";
import Individual from "../Common/icons/Individual";
import Group3 from "../Common/icons/Group3";
import Couple from "../Common/icons/Couple";
import Business from "../Common/icons/Business";

const DomesticHotelDetailCommentItem = props => {
    const { comment } = props;

        let travelTypeElement = null;

    switch (comment.travelType) {
        case "Business":
            travelTypeElement = <>
                <Business className='small-svg' /> کاری
            </>;
            break;
        case 'Couple':
            travelTypeElement = <>
                <Couple className='small-svg' /> زوج
            </>;
            break;
        case 'Family':
            travelTypeElement = <>
                <Couple className='small-svg' /> خانواده
            </>;
            break;
        case 'Group':
            travelTypeElement = <>
                <Group3 className='small-svg' /> گروهی
            </>;
            break;
        case 'Individual':
            travelTypeElement = <>
                <Individual className='small-svg' /> انفرادی
            </>;
            break;
        default:
            travelTypeElement = null;

    }


    return (
        <div className="comment-item">
            <span className="avatar-holder margin-end"><span className="itours-icon profile" /></span>
            <div className="flex-auto">
                <div className="pair-row">
                    <div>
                        <span className="semi-bold"> {comment.userDisplayName} </span>
                        {!!travelTypeElement && <span className="font-12 border-tag small-tag">{travelTypeElement}</span>}
                    </div>
                    <span className="font-13 gray">
                        {comment.creationTime && moment(comment.creationTime).format("jYYYY/jMM/jDD")}
                    </span>
                </div>
                <Bar persentage={comment.overallRating*10} className="margin-end-half" />
                {comment.overallRating*10} از 100

                <div className="font-13 margin-top-half">{parse(comment.comment)}</div>
            </div>
        </div>
    )
}

export default DomesticHotelDetailCommentItem;